// export const APP_NAME = 'Sama.IOT';
// export const APP_VERSION = '2.0';

// export const BASE_DOMAIN = 'https://sama-tech.ae'
// // export const BASE_DOMAIN = 'http://localhost'

// export const STRIPE_PUBLIC_KEY = 'pk_live_51RQ4JH2NTGtQziNhfgKFKF4XU7Va293AArrk5Y9d0MhwoY2GWZq3mCNdPKjbFWFiYcmsbwrtlvPm9h3iZtmKt5xP0024TsyTAP'

// export const BASE_URL = BASE_DOMAIN + '/iot' // + ':5000'
// export const BASE_URL_API = BASE_URL + '/api-v1'
// export const STATIC_FILES = BASE_URL + '/static/files/'
// export const STATIC_ICONS = BASE_URL + '/static/files/icons/'
// export const SENSORS_URL = BASE_DOMAIN + '/center' //:8080';
// export const OTA_URL = BASE_DOMAIN + '/ota' //':5100';

// export const BUCKET_DEVICES = "Sensors"

// export const defaultIcon = 'default-image.svg'
// export const defaultDatastreamIcon = 'datastream.svg'
// export const defaultShipmentIcon = 'shipping.svg'
// export const defaultDeviceCodeIcon = 'device-code.png'




export const APP_NAME = 'Sama.IOT';
export const APP_VERSION = '2.0';

 export const BASE_DOMAIN = 'https://sama-tech.ae'
//export const BASE_DOMAIN = 'http://localhost'
export const BASE_DOMAIN_PROD = 'https://sama-tech.ae'


export const STRIPE_PUBLIC_KEY = 'pk_test_51RQ4K6RrMlpQbguCu7Up7p1xvKlL0PyPV5PLnYyS3DqB9tqQKYszWQ4LS7ToMOWyShxDKmBiVWrRaTSOBSR6AQDZ00jBZFcdtR'

export const BASE_URL = BASE_DOMAIN  + '/iot' // + ':5000'
export const BASE_URL_API = BASE_URL + '/api-v1'
export const AI_VOICE_PROCESS_URL = BASE_URL_API + '/ai-voice/process'
export const AI_VOICE_SESSION_TTL_MINUTES =
  Number(process.env.REACT_APP_AI_VOICE_SESSION_TTL_MINUTES) > 0
    ? Number(process.env.REACT_APP_AI_VOICE_SESSION_TTL_MINUTES)
    : 15
export const STATIC_FILES = BASE_URL + '/static/files/'
export const STATIC_ICONS = BASE_URL + '/static/files/icons/'
export const SENSORS_URL = BASE_DOMAIN_PROD + '/center' //:8080';
export const OTA_URL = BASE_DOMAIN + '/test-ota' //':5100';

export const BUCKET_DEVICES = "Sensors"

export const defaultIcon = 'default-image.svg'
export const defaultDatastreamIcon = 'datastream.svg'
export const defaultShipmentIcon = 'shipping.svg'
export const defaultDeviceCodeIcon = 'device-code.png'
